import React, { FC } from "react";

import TableDetail from "../../components/Table/Detail";
import sourcecode from "../../constants/detail/sourcecode";
import sourcecodeForm from "../../constants/form/sourcecode";

const SourcecodeDetailPage: FC = () => <TableDetail modalForm={sourcecodeForm} form={sourcecode} />;

export default SourcecodeDetailPage;
